import './textarea.scss';
import LabelKMQ from "../Label/LabelKMQ";
import ErrorKMQ from "../Error/ErrorKMQ";
import {ChangeEvent, createRef, useEffect, ClipboardEvent, FocusEvent} from "react";

interface TextAreaProps {
  value: string,
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void,
  placeholder: string,
  error?: string,
  label?: string,
  readOnly?: boolean,
  disabled?: boolean,
  onPaste?: (event: ClipboardEvent<HTMLTextAreaElement>) => void,
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void
}

const TextArea = (props: TextAreaProps) => {
  const {
    value,
    onChange,
    placeholder,
    error,
    label,
    readOnly,
    disabled,
    onPaste,
    onBlur
  } = props;

  const textareaRef = createRef<HTMLTextAreaElement>();

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 24}px`;
    }
  }, [value])

  return <span className={`textarea ${error ? 'textarea-error' : ''} ${disabled ? 'textarea-disabled' : ''}`}>
    <LabelKMQ>{label}</LabelKMQ>
    <textarea
      ref={textareaRef}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onPaste={onPaste}
      onBlur={onBlur}
      rows={1}
      readOnly={readOnly || disabled}
      disabled={disabled}
    />
    <ErrorKMQ error={error}/>
  </span>
}

export default TextArea;